import { Button, Col, DatePicker, Divider, Form, Input, Modal, Row, Select, Spin } from "antd";

import { colInputs } from "./../GridStyle";
import { removeAcento } from "../../../utils/RemoveAcentos";

import { ptBR as portugues } from '@mui/x-date-pickers/locales';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ptBR } from "date-fns/locale/pt-BR";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { useState } from "react";

const { TextArea } = Input;

export const ModalFormVotacoes = ({
    isModalOpen,
    handleCancelModal,
    form,
    refForm,
    onClickBotaoSalvarModal,
    onClickBotaoEditarModal,
    loadingPage,
    isEditarVotacao,

    onClickAddTodosSeleCargos,
    refFormSelectCargos,
    refBotaoSeleCargos,
    dadosCargosList,
    defaultValueDatePickerInicio,
    defaultValueDatePickerFim,
}: any) => {

    const [visibleDatePickerInicio, onVisibleDatePickerInicio] = useState(false);
    const [visibleDatePickerFim, onVisibleDatePickerFim] = useState(false);

    return (
        <Modal
            title={isEditarVotacao ? "Editar votação" : "Adicionar votação"}
            width={1000}
            footer={false}
            open={isModalOpen}
            onOk={handleCancelModal}
            onCancel={handleCancelModal}
            destroyOnClose
        >
            <Spin spinning={loadingPage}>
                <Form
                    form={form}
                    ref={refForm}
                    name="formVotacao"
                    layout="vertical"
                    onFinishFailed={() => { }}
                >
                    <Row>
                        {/* <Col hidden {...inputNome}>
                        <Form.Item
                            name="idMembro"
                            label="id"
                            rules={[
                                {
                                    required: false,
                                    message: "Por favor preencha o id!",
                                },
                            ]}
                        >
                            <Input placeholder="id" disabled />
                        </Form.Item>
                    </Col> */}
                        <Col {...colInputs}>
                            <Form.Item
                                name="titulo"
                                label="Título"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, digite o título.",
                                    },
                                ]}
                            >
                                <Input placeholder="Eleições" />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                name="descricao"
                                label="Descrição"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            "Por favor, digite a descrição.",
                                    },
                                ]}
                            >
                                <TextArea
                                    autoComplete="off"
                                    rows={2}
                                    count={{}} // Exemplo de valor para o contador
                                    onClear={() => {}}
                                // style={{ maxHeight: 150, height: 20 }}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                name="dataInicio"
                                label="Data início"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, selecione a data.",
                                    }
                                ]}
                            >
                                <DatePicker
                                    style={{
                                        width: '100%'
                                    }}
                                    format={{
                                        format: 'DD/MM/YYYY HH:mm',
                                        type: 'mask',
                                    }}
                                    picker='date'
                                    showTime
                                    onClick={() => {
                                        onVisibleDatePickerInicio(true)
                                    }}
                                    popupStyle={{
                                        display: 'none'
                                    }}
                                    panelRender={() => (
                                        <LocalizationProvider
                                            adapterLocale={ptBR}
                                            localeText={portugues.components.MuiLocalizationProvider.defaultProps.localeText}
                                            dateAdapter={AdapterDateFns}
                                        >
                                            <MobileDateTimePicker
                                                // localeText={{}}
                                                open={visibleDatePickerInicio}
                                                onClose={() => {
                                                    onVisibleDatePickerInicio(false)
                                                }}
                                                onAccept={(value) => {
                                                    refForm.current?.setFieldsValue(
                                                        { dataInicio: dayjs(value), }
                                                    );
                                                }}
                                                defaultValue={defaultValueDatePickerInicio}
                                                ampmInClock={false}
                                                ampm={false}
                                                autoFocus
                                                format="dd/MM/yyyy HH:mm"
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                name="dataFim"
                                label="Data fim"
                                style={{ margin: 5 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, selecione a data.",
                                    }
                                ]}
                            >
                                <DatePicker
                                    style={{
                                        width: '100%'
                                    }}
                                    format={{
                                        format: 'DD/MM/YYYY HH:mm',
                                        type: 'mask',
                                    }}
                                    picker='date'
                                    showTime
                                    onClick={() => {
                                        onVisibleDatePickerFim(true)
                                    }}
                                    popupStyle={{
                                        display: 'none'
                                    }}
                                    panelRender={() => (
                                        <LocalizationProvider
                                            adapterLocale={ptBR}
                                            localeText={portugues.components.MuiLocalizationProvider.defaultProps.localeText}
                                            dateAdapter={AdapterDateFns}
                                        >
                                            <MobileDateTimePicker
                                                // localeText={{}}
                                                open={visibleDatePickerFim}
                                                onClose={() => {
                                                    onVisibleDatePickerFim(false)
                                                }}
                                                onAccept={(value) => {
                                                    refForm.current?.setFieldsValue(
                                                        { dataFim: dayjs(value), }
                                                    );
                                                }}
                                                defaultValue={defaultValueDatePickerFim}
                                                ampmInClock={false}
                                                ampm={false}
                                                autoFocus
                                                format="dd/MM/yyyy HH:mm"
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                name="cargosPermitidosIds"
                                label="Cargos permitidos"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, selecione um cargo.",
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    ref={refFormSelectCargos}
                                    // loading={loadingUsuariosSelected}
                                    // notFoundContent={loadingUsuariosSelected ? <Spin size="small" /> : null}
                                    optionFilterProp="children"
                                    placeholder="Selecione..."
                                    mode="multiple"
                                    filterOption={(input: any, option: any) => {
                                        let textDigit = removeAcento(input)
                                        let listCidade = removeAcento(option?.children);
                                        return listCidade.indexOf(textDigit) >= 0
                                    }}
                                    dropdownRender={menu => (
                                        <div>

                                            <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                                <Button
                                                    ref={refBotaoSeleCargos}
                                                    block
                                                    onClick={onClickAddTodosSeleCargos}
                                                    type="dashed"
                                                >Todos</Button>
                                            </div>
                                            <Divider style={{ margin: '4px 0' }} />
                                            {menu}
                                        </div>
                                    )}
                                >
                                    {
                                        dadosCargosList.map((item: any) => {
                                            return (
                                                <Select.Option
                                                    value={item.id}
                                                    key={item.id}
                                                >
                                                    {item.nome}
                                                </Select.Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: "end" }}>
                            <div
                                style={{ textAlign: "end", marginRight: 5, marginTop: 10 }}
                            >

                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={handleCancelModal}
                                >
                                    Cancelar
                                </Button>
                                {isEditarVotacao ? (
                                    <Button
                                        type="primary"
                                        loading={loadingPage}
                                        onClick={onClickBotaoEditarModal}
                                    >
                                        Atualizar
                                    </Button>
                                ) : (
                                    <Button
                                        type="primary"
                                        loading={loadingPage}
                                        onClick={onClickBotaoSalvarModal}
                                    >
                                        Salvar
                                    </Button>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
}
